import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setSearchSource } from '../../../../../redux/search/Actions';

import { MenuItem, makeStyles, Grid } from '@material-ui/core';
import SimpleSelect from '../../common/SimpleSelect';
import SimpleHeading from '../../common/SimpleHeading';
import SelectTextField from '../../../../Common/UI/SelectTextField';
import InputLabel from '../../../../Common/UI/InputLabel';


const useStyles = makeStyles((theme) => style(theme));

function SearchSettings () {
    const classes = useStyles();
    const source = useSelector(state => state.search.searchArea.layerId);
    const searchChoices = useSelector(state => {
        return state.user.features['siteFinder'].layers.map(siteFinderLayer => state.layers.layers.find(layer => layer.id === siteFinderLayer.layerId));
    });
    const dispatch = useDispatch();
    const dispatchSetSearchSource = (id) => dispatch(setSearchSource(id));

    function handleSourceChange (event) {
        dispatchSetSearchSource(event.target.value);
    }

    return (
        <div className={classes.root}>
            <SimpleHeading label="1. DEFINE YOUR SEARCH REQUIREMENTS" tooltip="Select dataset to search"/>
            <Grid container spacing={2} alignContent='center' alignItems='center'>
                <Grid item xs={4}><InputLabel label="Search By" /></Grid>
                <Grid item xs={8}>
                    <SelectTextField
                        data-intercom-target={`site-finder-search-by-multi-select`}
                        value={source || ''}
                        placeholder="select an option"
                        onChange={handleSourceChange}
                        fullWidth
                    >
                        {searchChoices.map((e, idx) => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
                    </SelectTextField>    
                </Grid>
            </Grid>
        </div>
    );
}

const style = theme => ({
    root: {
        '&> *:first-child':{
            marginBottom: theme.constants.verticalMargin
        }
    }
});

export default SearchSettings;